import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const savedLang = sessionStorage.getItem('appLang') ?? 'en';

void i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    lng: savedLang,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'admin', 'mentor', 'student', 'progress', 'help', 'pathfinder', 'privacy', 'practice'],
    preload: ['en', 'hi', 'kn'],
    interpolation: { escapeValue: false },

    // `fallbackLng: 'en'` keeps the UI readable when a key is absent, but it also
    // makes the absence invisible — an untranslated string renders as ordinary
    // English and nobody notices. (That is how `skillMap.lastUpdated` shipped
    // missing from all three locales, and the same silent-fallback shape as
    // `translation ?? englishName` on the content side.) Keep the fallback,
    // but make the miss loud in development. `npm run check:locales` is the
    // CI-side counterpart.
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lngs, ns, key) => {
      console.error(`[i18n] missing key "${ns}:${key}" for ${lngs.join(', ')}`);
    },
  });

export default i18next;
